import { Checkbox, Form } from "antd";
import React from "react";
import { RoleSelect } from "src/components/RoleSelect";
import { ZRolesGroup } from "src/pages/ManagementPage/Obj2Tab/roles/roleTypes";
import { ZRoleFields } from "../../../RolesTab.types";

interface PropsRoleCopyFields {
  roleGroups: ZRolesGroup[];
}

const fieldKey = (key: keyof ZRoleFields) => key;

export const RoleCopyFields: React.FC<PropsRoleCopyFields> = ({
  roleGroups,
}) => (
  <>
    <Form.Item
      name={fieldKey("copyRoleId")}
      label="Роль, с которой копируются настроенные права"
    >
      <RoleSelect single roleGroups={roleGroups} />
    </Form.Item>
    <div>
      <div>Скопировать права:</div>
      <Form.Item name={fieldKey("copyForObjects")} valuePropName="checked">
        <Checkbox>Для всех объектов</Checkbox>
      </Form.Item>
      <Form.Item name={fieldKey("copyForAttributes")} valuePropName="checked">
        <Checkbox>Для всех атрибутов</Checkbox>
      </Form.Item>
    </div>
  </>
);
